import { getSettings } from './Settings';

export default function getLocale() {
  const settings = getSettings();
  return settings.locale;
}
